/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CreateMediaTypeDto } from '../../models/create-media-type-dto';
import { MediaTypeItem } from '../../models/media-type-item';

export interface MediaTypeControllerCreate$Params {
      body: CreateMediaTypeDto
}

export function mediaTypeControllerCreate(http: HttpClient, rootUrl: string, params: MediaTypeControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaTypeItem;
}>> {
  const rb = new RequestBuilder(rootUrl, mediaTypeControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MediaTypeItem;
      }>;
    })
  );
}

mediaTypeControllerCreate.PATH = '/file-manager/types';
